import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Article from "../Main/Article";
import Content from "../Main/Content";
import BlogPreview from "./BlogPreview";

const styles = theme => ({
  invisible: {
    marginTop: -80,
    [`@media (max-width: ${theme.mediaQueryTresholds.L - 1}px)`]: {
      marginTop: 0,
      paddingTop: 20
    },
    paddingTop: theme.header.height.default,
    border: 0
  },
  invisibleFirst: {
    marginTop: -40,
    [`@media (max-width: ${theme.mediaQueryTresholds.L - 1}px)`]: {
      marginTop: 0,
      paddingTop: 20
    },
    paddingTop: theme.header.height.default,
    border: 0
  }
});

class Sections extends React.Component {
  static propTypes = {
    sections: PropTypes.array.isRequired,
    posts: PropTypes.array,
    separators: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { sections, separators, classes, posts } = this.props;

    return (
      <React.Fragment>
        {sections &&
          sections.map((section, i) => {
            return (
              <Article key={i}>
                <hr
                  ref={separators[i + 1]}
                  className={i === 0 ? classes.invisibleFirst : classes.invisible}
                />
                <Content html={section.node.html} />
              </Article>
            );
          })}

        <BlogPreview posts={posts}>
          <hr
            ref={separators[(sections && sections.length + 1) || 1]}
            className={classes.invisible}
          />
        </BlogPreview>
      </React.Fragment>
    );
  }
}

export default injectSheet(styles)(Sections);



// WEBPACK FOOTER //
// ./src/components/LandingPage/Sections.js